export const MAINTANCE_ERROR = 'MAINTANCE_ERROR';

export const MAINTANCE_STATUS_CODE = '503';
